import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { bem } from 'helpers/class-name';
import './Avatar.scss';

const { block } = bem('avatar');

const Avatar = memo(({ url, name, size, className, disabled = false, borderWidth = 1, ...props }) => {
  const style = {
    width: size,
    height: size,
  };

  return (
    <div className={block(className, { disabled })} {...props} style={style}>
      <span className="avatar__name">{name}</span>
      {url && (
        <img
          className="avatar__img"
          alt={name}
          src={url}
          width={size - borderWidth * 2}
          height={size - borderWidth * 2}
        />
      )}
    </div>
  );
});

Avatar.defaultProps = {
  size: 44,
};

Avatar.displayName = 'Avatar';

Avatar.propTypes = {
  url: PropTypes.string,
  name: PropTypes.string,
  size: PropTypes.number,
  borderWidth: PropTypes.number,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

export default Avatar;
